import AttachmentsContent from './AttachmentContent';

export default AttachmentsContent;
